import { Box, Card, CardProps, Divider, HStack, Icon, Text } from '@chakra-ui/react';
import { IoMdInformationCircle } from 'react-icons/io';

import ExpandableContent from '../../../components/ExpandableContent';
import { DealType } from '../../../gql/generated/graphql';
import { useJurisdictionDocs } from '../../../hooks';
import { dateOrdinal } from '../../../utils/dates';
import { DealStateEnum } from '../../../utils/types/deal';
import { DealWithFarthestState, dealStatusDescription, getDealStatusLabel } from '../utils';

interface Props extends CardProps {
  deal?: DealWithFarthestState;
}

const StatusDetails = ({ deal, ...rest }: Props) => {
  const { requiredDocs } = useJurisdictionDocs(deal, {
    skip: deal?.farthestState !== DealStateEnum.WaitingForTitle,
  });

  const firstState = deal?.deal_states?.reduce((prev, curr) => {
    if (curr?.state !== deal?.farthestState) {
      return prev;
    }
    if (new Date(curr?.created_at).getTime() < new Date(prev?.created_at).getTime()) {
      return curr;
    }
    return prev;
  });
  const date = new Date(firstState?.created_at);

  const month = date.toLocaleString('default', { month: 'long' });
  const day = `${date.getDate()}${dateOrdinal(date.getDate())}`;

  return (
    <Card
      border="1px solid"
      borderColor="gainsboro"
      shadow="md"
      px="30px"
      py="25px"
      alignItems={{ base: 'center', md: 'start' }}
      {...rest}
    >
      {deal?.farthestState !== DealStateEnum.Finalized && (
        <HStack>
          <Icon as={IoMdInformationCircle} w={6} h={6} color="black" />
          <Text fontWeight="semibold" lineHeight="22px">
            WHAT'S BEING WORKED ON
          </Text>
        </HStack>
      )}
      <Text
        fontWeight="bold"
        fontSize="42px"
        lineHeight="50px"
        my={2}
        textAlign={{ base: 'center', md: 'left' }}
      >
        {getDealStatusLabel(deal?.farthestState as DealStateEnum, deal?.type === DealType.Refi)}
      </Text>
      <Text mb={{ base: 0, md: '20px' }}>
        We started this on{' '}
        <b>
          {month} {day}
        </b>
      </Text>
      <Divider my="20px" display={{ md: 'none' }} borderColor="lightGray" />
      <ExpandableContent
        defaultHeight={150}
        enabled={deal?.farthestState !== DealStateEnum.SentForSignatures}
        key={deal?.farthestState}
      >
        <Box fontSize="16px">{dealStatusDescription({ deal, requiredDocs })}</Box>
      </ExpandableContent>
    </Card>
  );
};

export default StatusDetails;
